

// 支持的包格式 目标类型
const TARGET = ['server', 'doc', 'build', 'process'];

// 支持的语言类型
const LANGUAGE = ['es','bin','node', 'react', 'vue'];

// 支持的编译类型
const LIBRARY_TARGET_OBJ = {
    // umd的编译模式 使用与node 与 brower
    umd: { key: 'umd' },
    commonjs: { key: 'commonjs' },
    window: { key: 'window' },
    // es module 暂时为支持
    // module: { key: 'module' },
    // amd: { key: 'amd' },
    // system: { key: 'system' },
}

// 数组形式
let LIBRARY_TARGET = (() => {
    let res = [];
    for (prop in LIBRARY_TARGET_OBJ) {
        res.push(LIBRARY_TARGET_OBJ[prop].key)
    }
    return res;
})()

module.exports = {
    TARGET,
    LANGUAGE,
    LIBRARY_TARGET_OBJ,
    LIBRARY_TARGET
}